import { createStyles, makeStyles, Theme } from "@material-ui/core";

const buttonBgColor = "rgba(54, 123, 245, 0.2)";
const boxShadow = "0 0 8px 0 rgba(0, 0, 0, 0.08)";
export const inputWidth = "400px";

export default makeStyles((theme: Theme) =>
	createStyles({
		selectOptionButton: {
			minWidth: 0,
			textTransform: "none",
			whiteSpace: "nowrap",
			fontSize: "1rem",
			"&.MuiButton-root:hover": {
				backgroundColor: "transparent",
				boxShadow: "none",
			},
			"&:focus": {
				outline: "none",
			},
			"&:focusVisible": {
				outline: "none",
			},
		},
		icon: {
			borderRadius: 5,
			"&:hover": {
				backgroundColor: buttonBgColor,
			},
		},
		popoverPaper: {
			border: "none",
			boxShadow,
			minWidth: "514px",
			minHeight: "491px",
		},
		inputRoot: {
			padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
			flexGrow: 0,
		},
		inputField: {
			marginLeft: "15px",
			width: "100%",
		},
		sendIcon: {
			padding: 0,
			"&:hover": {
				backgroundColor: buttonBgColor,
			},
		},
		messagesRoot: {
			backgroundColor: "#f5f8f9",
			display: "flex",
			flexDirection: "column",
			width: "100%",
			maxHeight: "440px",
			justifyContent: "space-between",
		},
		gradientTop: {
			background: "linear-gradient( #f5f8f9, #ffffff )",
			minHeight: "20px",
			display: "flex",
			justifyContent: "flex-end",
			padding: "10px",
		},
		messagesContainer: {
			overflowY: "auto",
			flexGrow: 1,
		},
		messagesPaper: {
			padding: theme.spacing(2),
			marginLeft: "32px",
			position: "relative",
			zIndex: 0,
			flexGrow: 1,
		},
		messageStyle: {
			display: "flex",
			padding: theme.spacing(2),
			paddingBottom: 0,
			alignItems: "center",
			position: "relative",
			zIndex: 1,
			justifyContent: "space-between",
			minHeight: 50,
		},
		avatarRoot: {
			zIndex: 2,
			marginLeft: "-40px",
		},
		contentMessage: {
			fontWeight: 300,
			fontSize: "1rem",
			letterSpacing: "0.15px",
			whiteSpace: "pre-line",
		},
		contentContainer: {
			maxWidth: inputWidth,
			wordWrap: "break-word",
		},
		readMoreText: {
			color: theme.palette.primary.main,
			"&:hover": {
				backgroundColor: "transparent",
			},
			padding: 0,
		},
		smallFont: {
			fontSize: ".8rem",
		},
		smallFontSecondary: {
			fontSize: ".8rem",
			color: "#969392",
		},
		mentionsPopover: {
			border: "none",
		},
		sharingType: {
			padding: "2px 6px",
			fontWeight: 700,
			fontSize: "12px",
			textTransform: "uppercase",
			borderRadius: "4px",
			lineHeight: 1.35,
		},
		externalMessage: {
			color: "#7C4595",
			backgroundColor: "#ECE5F0",
		},
		internalMessage: {
			color: "#0B5A65",
			backgroundColor: "#D1E0E2",
		},
		baseAssignment: {
			padding: "2px 4px",
			borderRadius: "2px",
			textTransform: "uppercase",
			fontSize: ".7rem",
			whiteSpace: "nowrap",
		},
		assignment: {
			backgroundColor: "#D8F3FF",
			color: theme.palette.primary.main,
			whiteSpace: "nowrap",
		},
		resolvedAssignment: {
			backgroundColor: "#E8F3D9",
			color: "#4C7057",
		},
		tooltip: {
			whiteSpace: "nowrap",
			maxWidth: "none",
		},
		newMessageHeader: {
			backgroundColor: "#F6F2F8",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			padding: "8px 24px",
			marginBottom: 16,
		},
		newMessageInternal: {
			backgroundColor: "#EDF2F2",
		},
		newMessageExternal: {
			backgroundColor: "#F6F2F8",
		},
	})
);
